import { useGetZoomMetadata } from './api/useGetZoomMetadata';
import { useGetZoomToken } from './api/useGetZoomToken';
import { ZoomAuthType } from './types/zoom-metadata';

interface UseZoomAuthOptions {
  clientRedirect?: string;
}

export function useZoomAuth(options?: UseZoomAuthOptions) {
  const { data: zoomData, isLoading } = useGetZoomMetadata();
  const { mutateAsync: getZoomToken, isLoading: isTokenLoading } = useGetZoomToken();
  const isZoomAuthed = zoomData?.authRequired === false;

  const buildAuthUrl = (url: string): string => {
    if (!options?.clientRedirect) return url;
    const authUrl = new URL(url);
    const state = authUrl.searchParams.get('state') ?? '';
    authUrl.searchParams.set('state', `${state}?clientRedirect=${options.clientRedirect}`);
    return authUrl.toString();
  };

  const handleZoomRedirectConnect = () => {
    const zoomAuthURL = buildAuthUrl(zoomData!.authUrl);
    window.location.href = zoomAuthURL;
  };

  const handleGetZoomToken = async () => {
    const zoomAuthURL = buildAuthUrl(zoomData!.authUrl);
    const zoomAuthHeader = zoomData!.authHeader;

    const zoomAuthLink = await getZoomToken({
      url: zoomAuthURL,
      token: zoomAuthHeader,
    });

    window.open(zoomAuthLink, '_blank', 'noopener,noreferrer');
  };

  const handleZoomConnect = () => {
    const authType = zoomData?.authType;
    if (authType === ZoomAuthType.Redirect) {
      return void handleZoomRedirectConnect();
    }

    if (authType === ZoomAuthType.Device) {
      return void handleGetZoomToken();
    }
  };

  return {
    isZoomAuthed,
    isLoading,
    isTokenLoading,
    handleZoomConnect,
  };
}
